import React, { useState } from "react";
import explore from "../../../assets/images/Icons/HomePage - Icons/file.svg";
import scanner1 from "../../../assets/images/Icons/HomePage - Icons/scanner1.svg";

const FloatingBTN: React.FC = () => {
  const [showScanner, setShowScanner] = useState(false);

  const toggleScanner = () => setShowScanner((prev) => !prev);

  return (
    <>
      {/* Desktop View */}
      <div className="d-none d-md-block">
        <div
          style={{
            position: "fixed",
            top: "28%",
            right: 0,
            zIndex: 9999,
            width: "370px",
            height: "150px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "390px",
              height: "150px",
            }}
          >
            {/* Explore Image */}
            <img
              src={explore}
              alt="Explore"
              role="button"
              tabIndex={0}
              style={{
                position: "absolute",
                top: 0,
                left: showScanner ? "-100%" : "294px",
                width: "80px",
                height: "150px",
                objectFit: "contain",
                transition: "left 0.4s ease",
                cursor: "pointer",
              }}
              onMouseEnter={() => setShowScanner(true)}
            />

            {/* Scanner Image */}
            <img
              src={scanner1}
              alt="Scanner"
              role="button"
              tabIndex={0}
              style={{
                position: "absolute",
                top: 0,
                left: showScanner ? "0%" : "100%",
                width: "100%",
                height: "150px",
                objectFit: "contain",
                transition: "left 0.4s ease",
                cursor: "pointer",
              }}
              onMouseLeave={() => setShowScanner(false)}
            />
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div className="d-block d-md-none">
        <div
          style={{
            position: "fixed",
            top: "28%",
            right: "0px",
            zIndex: 9999,
            width: showScanner ? "200px" : "40px",
            height: "80px",
            transition: "width 0.3s ease",
          }}
        >
          <img
            src={showScanner ? scanner1 : explore}
            alt={showScanner ? "Scanner" : "Explore"}
            role="button"
            tabIndex={0}
            style={{
              width: showScanner ? "200px" : "40px",
              height: "80px",
              objectFit: "contain",
              transition: "width 0.3s ease",
              cursor: "pointer",
            }}
            onClick={toggleScanner}
          />
        </div>
      </div>
    </>
  );
};

export default FloatingBTN;